// store/features/api/taxApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BACKEND_API_URL } from "../../../utility/api";

export const taxApi = createApi({
  reducerPath: "taxApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${BACKEND_API_URL}tax/`,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token || localStorage.getItem("token");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["Tax"],
  endpoints: (builder) => ({
    getTaxes: builder.query({
      query: (params) => ({
        url: "",
        params,
      }),
      providesTags: ["Tax"],
    }),
    getTax: builder.query({
      query: (id) => `/${id}`,
      providesTags: ["Tax"],
    }),
    addTax: builder.mutation({
      query: (data) => ({
        url: "",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Tax"],
    }),
    updateTax: builder.mutation({
      query: ({ id, data }) => ({
        url: `/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Tax"],
    }),
    deleteTax: builder.mutation({
      query: (id) => ({
        url: `/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Tax"],
    }),
    toggleTaxStatus: builder.mutation({
      query: (id) => ({
        url: `/${id}/status`,
        method: "PATCH",
      }),
      invalidatesTags: ["Tax"],
    }),
  }),
});

export const {
  useGetTaxesQuery,
  useGetTaxQuery,
  useAddTaxMutation,
  useUpdateTaxMutation,
  useDeleteTaxMutation,
  useToggleTaxStatusMutation,
} = taxApi;
